import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { sendAmountBlock } from "../../redux/InwardIteraction/actions";
import InwardXml from "../Nip/InwardInteraction";

const AmountBlock = (props) => {
  const {
    goToAccountBlock,
    goToFundTransferAdviceDirectDebit,
    sendType,
    amountBlock,
    isLoading,
  } = props;

  const handleAmountBlock1 = () => {
    const payload = {
      type: "balance_enquiry",
    };
    sendType(payload);
  };

  const handleAmountBlock2 = () => {
    const payload = {
      type: "amount_block",
    };
    sendType(payload);
  };

  const request = amountBlock && amountBlock.request;
  const response = amountBlock && amountBlock.response;

  return (
    <InwardXml
      prev={goToFundTransferAdviceDirectDebit}
      next={goToAccountBlock}
      title={"Amount Block"}
      request={request}
      response={response}
      optiontitle1={"Balance Enquiry (BE)"}
      optiontitle2={"Amount Block"}
      handleCase1={handleAmountBlock1}
      handleCase2={handleAmountBlock2}
      isLoading={isLoading}
    />
  );
};

AmountBlock.propTypes = {
  amountBlock: PropTypes.shape({
    request: PropTypes.string,
    response: PropTypes.string,
  }),
  goToAccountBlock: PropTypes.func,
  goToFundTransferAdviceDirectDebit: PropTypes.func,
  isLoading: PropTypes.bool,
  sendType: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isLoading,
    sendAmountBlockSuccess: state.inwardInteraction.sendAmountBlockSuccess,
    amountBlock: state.inwardInteraction.sendAmountBlock,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendType: (payload) => dispatch(sendAmountBlock(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AmountBlock);
